import { Modal, type ModalProps } from '@mantine/core'

import { IconClose } from './icons'
import { useIsMobile } from './useIsMobile'

/**
 * The app's modal: full screen on a phone-sized window, a centred dialog otherwise. Mantine's fullScreen is a plain
 * boolean, not responsive, so it cannot be a theme default; every dialog goes through here instead. Its close button
 * is always labelled "Close", never an icon alone (identity.md §5).
 */
export function AppModal(props: ModalProps) {
  const mobile = useIsMobile()
  return (
    <Modal
      fullScreen={mobile}
      closeButtonProps={{ children: 'Close', icon: <IconClose size={18} />, className: 'mt-close-pill' }}
      {...props}
    />
  )
}
